import type { Material } from '@babylonjs/core/Materials/material';
import { Texture } from '@babylonjs/core/Materials/Textures/texture';

/**
 * Fine see-through patterns: the welded wire mesh of the site fence (2.5 mm wires on a 10 × 20 cm grid, 256 px per
 * 0.4 m) and the scaffold netting. The camera sees them almost edge-on along the road; anisotropic filtering keeps the
 * wires sharp far into the distance, so with every bit of motion they land on other pixels and flicker – measured
 * 2026-10-03 by moving the frozen camera 2 cm: the fence mesh jumped all over, road, barriers and buildings stayed calm
 * (user: "das Flackern … ab einer gewissen Geschwindigkeit … gewisse Dinge nicht, aber manche schon"). Plain
 * trilinear filtering blends them into an even, see-through grey with distance – as the eye sees a real fence.
 */
export const FINE_PATTERN_MATERIALS: readonly string[] = ['MAT_FENCE_MESH', 'MAT_ROADSIDE_NET'];

/** True for the materials whose textures get the calm filtering. */
export function isFinePattern(materialName: string): boolean {
  return FINE_PATTERN_MATERIALS.includes(materialName);
}

/** No anisotropic filtering, trilinear mipmaps – for the textures of a fine see-through pattern material. */
export function calmFinePattern(material: Material): void {
  if (!isFinePattern(material.name)) return;
  for (const texture of material.getActiveTextures()) {
    texture.anisotropicFilteringLevel = 1;
    if (texture instanceof Texture) texture.updateSamplingMode(Texture.TRILINEAR_SAMPLINGMODE);
  }
}
